export default class PlanDayFilter {
  constructor({ date, employeeCode, departmentCode, establishmentCode }) {
    this.date = date;
    this.employeeCode = employeeCode;
    this.departmentCode = departmentCode;
    this.establishmentCode = establishmentCode;
  }
}
